var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginLayout',[_c('div',{staticClass:"mb-0 LoginCard"},[_c('div',{staticClass:"card-body"},[(!_vm.user || !_vm.email)?_c('GenerateCode'):_c('SetNewPassword')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }